import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { AutofillMixin, FieldMixin } from '../mixins';

@Component
export default class TextField extends mixins(FieldMixin, AutofillMixin) {

}
